import { gql } from '@apollo/client';

export const RESTORE_ENTITY_MUTATION = gql`
  mutation restoreEntity($resourceName: String!, $id: Int!) {
    restoreEntity(
      resourceName: $resourceName
      id: $id
    ) {
      successful
    }
  }
`;

export const RESTORE_USER_ENTITY_MUTATION = gql`
  mutation restoreUserEntity($resourceName: String!, $id: Int!) {
    restoreUserEntity(
      resourceName: $resourceName
      id: $id
    ) {
      successful
    }
  }
`;

export const RESTORE_REPORT_ENTITY_MUTATION = gql`
  mutation restoreReportEntity($resourceName: String!, $id: Int!) {
    restoreReportEntity(
      resourceName: $resourceName
      id: $id
    ) {
      successful
    }
  }
`;

export const RESTORE_NOTIFICATION_ENTITY_MUTATION = gql`
  mutation restoreNotificationEntity($resourceName: String!, $id: Int!) {
    restoreNotificationEntity(
      resourceName: $resourceName
      id: $id
    ) {
      successful
    }
  }
`;
